import {
  all, call, fork, put, select, takeLatest,
} from 'redux-saga/effects';
import { isFunction, cloneDeep } from 'lodash';
import {
  FETCH_ADMIN_BALANCES,
  FETCH_ADMIN_INFO,
  FETCH_ADMIN_LOGIN_HISTORY,
  FETCH_ADMINS,
  FETCH_ALL_ADMIN,
  FETCH_AUTH_INFO,
  FETCH_LIMIT_WITHDRAWAL_OF_ADMIN,
  GET_ROLE_FOR_USER,
  ON_CREATE_ADMIN,
  POST_ROLE_FOR_USER,
  SET_LIMIT_WITHDRAWAL_FOR_ADMIN,
  FETCH_BAN_ADMIN,
  FETCH_UN_BAN_ADMIN,
  FETCH_DEL_ADMIN,
  FETCH_OWN_BALANCE,
} from '../actions/admin/action_types';
import actions from '../actions/admin';
import rf from '../../requests/RequestFactory';
import utils from '../../common/utils';

function* fetchAllAdmins(action) {
  try {
    const { data } = yield call(
      (params) => rf.getRequest('AdminRequest').fetchAllAdmins(params),
      action.params,
    );
    yield put(actions.onFetchAllAdminSucceed(data));
  } catch (err) {
    console.log(err, 'err');
    yield put(actions.onFetchAllAdminFailed(err));
  }
}

function* fetchAdminLoginHistory(action) {
  try {
    const { data } = yield call(
      (params) => rf.getRequest('AdminRequest').fetchAdminLoginHistory(params),
      action.params,
    );
    yield put(actions.onFetchAdminLoginHistorySucceed(data));
  } catch (err) {
    yield put(actions.onFetchAdminLoginHistoryFailed(err));
  }
}

function* createAdmin(action) {
  try {
    yield call(
      (params) => rf.getRequest('AdminRequest').createAdmin(params),
      action.params,
    );

    yield put(actions.onFetchAllAdmin());
    yield action.callback();
    yield utils.showNotification('Thông báo!', 'Thành công!', 'success');
  } catch (err) {
    console.log(err, 'err');
    yield action.callback();
    yield put(actions.onFetchAllAdminFailed(err));
  }
}

function* fetchGetRoleByPubkey(action) {
  try {
    const data = yield call(
      (params) => rf
        .getRequest('AuthorizationRequest')
        .fetchGetRoleByPubkey(params),
      action.params,
    );
    if (isFunction(action.callback)) {
      yield action.callback(action.params, data.data);
    }
    // yield put(actions.getRolesSucceed(data.data,data.total_count));
  } catch (err) {
    console.log('err', err);
  }
}

function* fetchPostRoleForUserSaga(action) {
  try {
    const res = yield call(() => rf
      .getRequest('AuthorizationRequest')
      .fetchPostRoleForUser(action.params));

    console.log('res:----', res);
    if (res.data.message === 'Succeed') {
      utils.showNotification('Thông báo!', 'Thành công!');
    }
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  } catch (err) {
    yield action.callback();
    console.log('err', err);
  }
}

function* fetchAuthInfo(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminRequest').adminAuthInfo(params), action.params);
    yield put(actions.onFetchAuthInfoSucceed(data));
  } catch (err) {
    console.log(err, 'err');
    yield put(actions.onFetchAuthInfoFailed(err));
  }
}

function* fetchAdminInfo(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('AdminRequest').fetchAdminInfo(params), action.params);
    yield put(actions.onFetchAdminInfoSucceed(data));
  } catch (err) {
    console.log(err, 'err');
    yield put(actions.onFetchAdminInfoFailed(err));
  }
}

function* fetchLimitWithdrawOfAdmin(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('SettingRequest').fetchLimitAdminWithdrawal(params), action.params);
    let coins = yield select((state) => state.setting.coins);
    coins = cloneDeep(coins);
    yield put(actions.fetchLimitWithdrawalOfAdminSucceedAction(data, coins));
  } catch (err) {
    console.log(err, 'err');
    yield put(actions.fetchLimitWithdrawalOfAdminFailedAction(err));
  }
}

function* setLimitWithdrawForAdmin(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('SettingRequest').setLimitWithdrawalForAdmin(params), action.params);
    if (isFunction(action.callback)) {
      action.callback();
    }
    yield put(actions.fetchLimitWithdrawalOfAdminAction({ pubkey: action.params.pubkey }));
  } catch (err) {
    yield put(actions.setLimitWithdrawalForAdminFailedAction(err));
  }
}

function* fetchAdminBalances() {
  try {
    const resp = yield call(() => rf.getRequest('UserRequest').userBalances());

    yield put(actions.fetchAdminBalancesSucceedAction(resp.data));
  } catch (err) {
    yield put(actions.fetchAdminBalancesFailedAction(err));
  }
}

function* banAdmin(action) {
  try {
    const resp = yield call((params) => rf.getRequest('AdminRequest').banAdmin(params), action.params.data);
    if (resp.error.code === 200) {
      utils.showNotification('Thông báo', 'Cấm thành công', 'success');
      action.callback();
    }
  } catch (err) {
    console.log('error ban admin', err);
  }
}

function* unBanAdmin(action) {
  try {
    const resp = yield call((params) => rf.getRequest('AdminRequest').unBanAdmin(params), action.params.data);
    if (resp.error.code === 200) {
      utils.showNotification('Thông báo', 'Bỏ cấm thành công', 'success');
      action.callback();
    }
  } catch (err) {
    console.log('error ban admin', err);
  }
}

function* delAdmin(action) {
  try {
    const resp = yield call((params) => rf.getRequest('AdminRequest').delAdmin(params), action.params);
    if (resp.error.code === 200) {
      utils.showNotification('Thông báo', 'Xóa thành công', 'success');
      action.callback();
    }
  } catch (err) {
    console.log('error del admin', err);
  }
}

function* fetchOwnBalance(action) {
  try {
    const { data } = yield call(() => rf.getRequest('AdminRequest').fetchOwnBalances(), action.params);
    yield put(actions.fetchOwnBalanceSuccess(data));
    if (isFunction(action.callback)) {
      action.callback(data);
    }
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchOwnBalanceFailed(err));
  }
}

function* watchAdmins() {
  yield takeLatest(FETCH_ADMINS, fetchAllAdmins);
  yield takeLatest(FETCH_ADMIN_LOGIN_HISTORY, fetchAdminLoginHistory);
  yield takeLatest(ON_CREATE_ADMIN, createAdmin);
  yield takeLatest(GET_ROLE_FOR_USER, fetchGetRoleByPubkey);
  yield takeLatest(POST_ROLE_FOR_USER, fetchPostRoleForUserSaga);
  yield takeLatest(FETCH_AUTH_INFO, fetchAuthInfo);
  yield takeLatest(FETCH_LIMIT_WITHDRAWAL_OF_ADMIN, fetchLimitWithdrawOfAdmin);
  yield takeLatest(SET_LIMIT_WITHDRAWAL_FOR_ADMIN, setLimitWithdrawForAdmin);
  yield takeLatest(FETCH_ADMIN_INFO, fetchAdminInfo);
  yield takeLatest(FETCH_ADMIN_BALANCES, fetchAdminBalances);
  yield takeLatest(FETCH_BAN_ADMIN, banAdmin);
  yield takeLatest(FETCH_UN_BAN_ADMIN, unBanAdmin);
  yield takeLatest(FETCH_DEL_ADMIN, delAdmin);
  yield takeLatest(FETCH_OWN_BALANCE, fetchOwnBalance);
}

export default function* rootSaga() {
  yield all([fork(watchAdmins)]);
}
